import { render } from "./CubeTimer.vue?vue&type=template&id=226ed7d6&scoped=true"
import script from "./CubeTimer.vue?vue&type=script&lang=js"
export * from "./CubeTimer.vue?vue&type=script&lang=js"

import "./CubeTimer.vue?vue&type=style&index=0&id=226ed7d6&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226ed7d6"]])

export default __exports__